<template>
    <div class="w-full h-full p-10">
        <div
            class="flex flex-row gap-2 cursor-pointer"
            @click="handleGoBack">
            <hi-arrow-left-icon
                class="close-button w-7 h-7"
                aria-hidden="true" />
            <h3>
                {{ $t('labels.back') }}
            </h3>
        </div>
        <map-routing
            :routing-option="routingInfo"
            :routing-is-selected="routingIsSelected"
            :disabled="false"
            action="edit" />
    </div>
</template>
<script setup lang="ts">
import MapRouting from './ignore/screen/map-routing.vue'

definePageMeta({
  layout: 'full-screen'
})
const routingInfo = ref([])
const route = useRoute()
const routingIsSelected = reactive<{ [key: string]: any }>({})
onMounted(() => {
  // routingId.value = route.params.id
  const api = $url.routing.get
  $api(api, {
    uriParams: { id: route.params.id }
  })
    .then((data) => {
      if (!data) {
        return true
      }
      const responseData: any = data.data.value
      if (responseData.success) {
        routingInfo.value = responseData.data.node
        Object.assign(routingIsSelected, { ...responseData.data })
      }
    })
    .catch((error: any) => error)
})
const handleGoBack = () => {
  useRouter().back()
}
</script>
